var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', [_c('div', {
    staticClass: "\n    d-flex\n    flex-wrap flex-nowrap\n    justify-content-between\n    padding-top-2x padding-bottom-1x\n  "
  }, _vm._l(_vm.items, function (item, index) {
    return _c('step', {
      key: index,
      attrs: {
        "title": _vm.$t(item.title),
        "isCompleted": _vm.isPrevious(item),
        "isActive": item.path === _vm.current.path,
        "number": index + 1
      }
    });
  }), 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }